export { FullNameField, NameInput } from './FullNameField';
export { checkFirstName, checkLastName, checkMatchNameBirthday, checkMatchNameEmail, checkMatchNamePhone, checkMiddleName, checkName, } from './FullNameField.validation';
